// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { FBLogin } from '../../../../../utils/facebook';
import Loading from '../../../../../elements/Loading/Loading';
import Modal from '../../../../../elements/Modal/Modal';
import { getBrowserLanguage } from '../../../../local-values/utils/countries';

import style from './AlreadyExistsFacebookAccount.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import facebookLogo from '../../../../../assets/img/social/facebook.png';

import type { FBLoginResponse } from '../../../../../utils/facebook';
import type { HTTPError } from '../../../../../error';
import type { Language } from '../../../../../entities';
import type { LocaleState } from '../../../../locale/duck';

type Props = {
  +handleClose: () => void;
  +fbLogin: (country: ?string, language: Language, token: string,
             email?: string, redirectTo?: string) => void;
  +isOpen?: boolean;
  +isAuthing?: boolean;
  +redirectTo?: string;
  +authError?: HTTPError;
  +locale: LocaleState;
};

export default class AlreadyExistsFacebookAccount extends Component<Props, void> {

  handleLoginFB(e: Event) {
    const { fbLogin, redirectTo, locale } = this.props;
    FBLogin(window).then((response: FBLoginResponse) => {
      if (response.status === 'connected' && response.authResponse) {
        const localeUpper = locale.locale ? locale.locale.toUpperCase() : '';
        const lang = localeUpper || getBrowserLanguage();
        fbLogin(locale.country, lang, response.authResponse.accessToken, undefined, redirectTo);
      }
    });
  }

  render() {
    const { isOpen, handleClose, isAuthing, authError } = this.props;
    return (
      <Modal open={isOpen}
             width={544}
             height={312}
             handleClose={() => !isAuthing && handleClose()}>
        {isAuthing ? <Loading type="sk-three-bounce"
                              className={style.modalLoading}
                              number={3}/> :
          <section className={style.alreadyExistFacebookAccount}>
            <FormattedMessage id="modal.alreadyExistFacebookAcount.title">{
              text => <h2>{text}</h2>
            }</FormattedMessage>
            {authError && authError.data && authError.data.name === 'UserExistsWithFacebookError' &&
            <p>{authError.data.detail.email}</p>
            }
            <FormattedMessage id="auth.facebook.button">{
              txt => (<button type="button"
                              disabled={isAuthing}
                              onClick={this.handleLoginFB.bind(this)}
                              className={classNames(buttonStyle.socialBtn, buttonStyle.facebook)}>
                <img src={facebookLogo} alt="facebook"/>
                <span>{txt}</span>
              </button>)
            }</FormattedMessage>
          </section>
        }
      </Modal>
    )
  }
}

AlreadyExistsFacebookAccount.propTypes = {
  handleClose: PropTypes.func.isRequired,
  fbLogin: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isAuthing: PropTypes.bool,
  redirectTo: PropTypes.string,
  authError: PropTypes.object,
  locale: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/already-exists-facebook-account/component/AlreadyExistsFacebookAccount.jsx